import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { BackNativeService } from '../../service/comunicator-native/back-native/back-native';
import { ReturnNativeService } from '../../service/comunicator-native/return-native/return-native';
import { JourneyService } from '../../service/journey/journey.service';
import { DefaultPageComponent } from '../default-page.component';
import { ParamDefaultGA4 } from '../../service/comunicator-native/track-ga4-native/itrack-ga4-native';
import { AnalyticsGA4PageService } from '../../service/analytics-ga4-pages/analytics-ga4-page.service';

interface AnalyticsGA4Page {
  paramDefautl: ParamDefaultGA4, 
  paramComplementary?: Record<string, string>
}

@Component({
  selector: 'app-details-faq',
  templateUrl: './details-faq.component.html',
  styleUrls: ['./details-faq.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DetailsFaqComponent extends DefaultPageComponent implements OnInit {

  content: any = [];
  contentFooter: string;
  titleContent: "Perguntas frequentes";
  idFocusBack: string;
  ariaHidden = true;
  headerId = 'back-detail-page-faq';
  labelBtnBack = 'voltar';
  pageLoaded: boolean;
  voicePageLoaded: boolean;
  analyticsPageGA4: AnalyticsGA4Page;

  constructor(
    public router: NavController,
    private route: Router,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    public backNativeService: BackNativeService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.loadData();
  }

  ngOnInit() {
    this.checkPageHasLoading();
  }

  checkPageHasLoading() {
    if (this.pageLoaded) {
      this.labelBtnBack = 'Tela carregada, voltar'
      this.headerFocus();
      setTimeout(() => this.labelBtnBack = 'voltar', 1000);
    } else {
      this.headerFocus();
    }
  }

  backPage() {
    localStorage.setItem(this.idFocusBack, this.idFocusBack);
    this.router.pop();
  }

  loadData() {
    const data = this.route.getCurrentNavigation().extras.state?.data;
    if (data) {
      this.content = data.faq;
      this.contentFooter = data?.contentFooter ?? "";
      this.idFocusBack = data?.index;
      this.pageLoaded = data?.pageLoadedOnlyScreenReader;
      this.analyticsPageGA4 = data?.analyticsPageGA4;
    }

    if (this.analyticsPageGA4) {
      this.sendTrackGA4LoadPage();
    }
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.paramDefautl.event_name,
      custom_path: this.analyticsPageGA4.paramDefautl.custom_path,
      implementation_team: this.analyticsPageGA4.paramDefautl.implementation_team,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

}
